import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
  flex: 1 1 0;
  max-width: 600px;
  width: 80%;
  max-width: 44rem;
`;
